/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';

import { Icon } from 'sarsaparilla';

import { MapControlButton } from './MapControlButton';

interface MapExpandButtonProps {
    isExpanded: boolean;
    onToggle: () => void;
    gaTrackingId?: string;
    gaTrackingValue?: string;
    className?: string;
}

export function MapExpandButton({
    isExpanded,
    onToggle,
    gaTrackingId,
    gaTrackingValue,
    className,
}: MapExpandButtonProps) {
    return (
        <MapControlButton
            onClick={onToggle}
            gaTrackingId={gaTrackingId}
            gaTrackingValue={gaTrackingValue}
            className={className}
            aria-label={isExpanded ? 'Close' : 'Full Screen'}
        >
            <Icon iconName={isExpanded ? 'close' : 'expand'} />
        </MapControlButton>
    );
}
